import { Redirect, useSearch } from "wouter";

export const CONTACTS_BASE_PATH = "/settings/contacts";

/**
 * Redirects the legacy top-level `/contacts` route to its new home under
 * Settings, preserving any query string (account/search filters) so existing
 * deep links keep working. `/contacts/:contactId` remains a contact detail page.
 */
export const ContactsRedirect = () => {
  const search = useSearch();
  const target = `${CONTACTS_BASE_PATH}${search ? `?${search}` : ""}`;
  return <Redirect to={target} replace />;
};
